import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '@augusoft/asf-core';
import { Observable, of } from 'rxjs';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class SecureApiService extends ApiService  {
  protected headers: {name: string, value: string}[] = [];
  constructor(
    protected authService: AuthService,
    protected router: Router,
    protected http: HttpClient, @Inject('apiUrl') apiUrl: string) {
      super(apiUrl, http);
      console.log('secure api service created', {apiUrl, loginUrl: authService.loginUrl}, this)
      this.authService.user.subscribe(user => {
        if (user) {
          this.addHeader('X-Api-Key', user.token);
        } else {
          this.removeHeader('X-Api-Key');
        }
      });
  }

  // // Include token
  // public getCustomHeaders(dataType: 'json' | 'formData' = 'json'): HttpHeaders {
  //   const token = this.authService.token;
  //   if (!token) {
  //      throw Error('Secure api calls can only be made if there is an active user');
  //   }

  //   let headers = new HttpHeaders();
  //   for (let h of this.headers) {
  //     headers = headers.set(h.name, h.value);
  //   }
  //   switch (dataType) {
  //     case 'json':
  //       const headers = new HttpHeaders()
  //         .set('X-Api-Key', token.toString())
  //         .set('Content-Type', 'application/json');
  //         return headers;

  //     case 'formData':
  //       return new HttpHeaders()
  //         .set('X-Api-Key', token.toString())
  //   }
  // }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  protected handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      switch (error.status) {
        case  401:
          this.authService.logout();
          console.log('Authorozation failed');
          // this.router.navigate([this.authService]);

          throw Error('Authorozation failed');
        case 500:
          console.log('Internal server error', error);
          throw error;
        case 0:
            throw new Error('A network error occured while connecting to the API server');
        case 404:
            // not found
            return of(error.error);
        case 403:
            // forbidden
            throw error;
      }
      // console.error(error); // log to console instead

      // // TODO: better job of transforming error for user consumption
      // console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
